export const makeSelectWorksheets = (state: AppState) => state.worksheetReducer.worksheets;

export const makeSelectCurrentWorksheet = (state: AppState) =>
  state.worksheetReducer.currentWorksheet;

export const makeSelectWorksheetAnswerError = (state: AppState) =>
  state.worksheetReducer.addAnswerToWorksheetError;
export const makeSelectFromCompletedWorksheet = (state: AppState) =>
  state.worksheetReducer.fromCompletedWorksheet;
